// App.jsx
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import JobsPage from './pages/JobsPage';
import TrackingPage from './pages/TrackingPage';
import FinancePage from './pages/FinancePage';
import ReportsPage from './pages/ReportsPage';
import MastersPage from './pages/MastersPage';
import JobDetailsPage from './pages/JobDetailsPage';
import CreateJobPage from './pages/CreateJobPage';
import NotificationProvider from './contexts/NotificationContext';
import AuthProvider from './contexts/AuthContext';
import ThemeProvider from './contexts/ThemeContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import LoadingSpinner from './components/ui/LoadingSpinner';
import ProtectedRoute from './components/common/ProtectedRoute';
import PublicRoute from './components/common/PublicRoute';
import { Toaster } from 'react-hot-toast';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate app initialization
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingSpinner fullScreen />;
  }

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          {/* <NotificationProvider> */}
            <Router>
              <Routes>
                {/* Public Routes - Only accessible when NOT authenticated */}
                <Route element={<PublicRoute />}>
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/" element={<Navigate to="/login" replace />} />
                </Route>

                {/* Protected Routes - Only accessible when authenticated */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/jobs/create" element={<CreateJobPage />} />
                  <Route path="/jobs/:id" element={<JobDetailsPage />} />
                  <Route path="/tracking" element={<TrackingPage />} />
                  <Route path="/finance" element={<FinancePage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/masters" element={<MastersPage />} />
                </Route>

                {/* Fallback Route - Redirect based on authentication status */}
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>

              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
            </Router>
          {/* </NotificationProvider> */}
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;